import { arrowBearing } from "../radar/radar";
import "./signs.css";

export interface CapitalGuess {
  name: string;
  km: number;
  dir: string;
}

/** Today's question on a green motorway gantry: flag, country, and the free first letter once earned. */
export function QuestionSign({ code, name, hint }: { code: string; name: string; hint?: string | undefined }) {
  return (
    <div className="rs rs-gantry">
      <div className="rs-gantry-row">
        <img src={`/flags/${code.toLowerCase()}.svg`} alt="" />
        <span className="rs-gantry-name">{name}</span>
      </div>
      <div className="rs-gantry-q">
        столиця?
        {hint && <span className="rs-hint">{hint}…</span>}
      </div>
    </div>
  );
}

/**
 * One guess as road signs, newest on top. A miss is a crossed-out city-limits
 * sign with a direction plate (km + arrow toward the real capital); the right
 * one is the entry sign. `fresh` plays the drop-and-swing.
 */
export function GuessSign({ guess, fresh }: { guess: CapitalGuess; fresh: boolean }) {
  if (guess.km === 0) {
    return (
      <div className={`rs rs-welcome ${fresh ? "rs-new" : ""}`}>
        <div className="rs-board">Ласкаво просимо!</div>
        <div className="rs-city">{guess.name}</div>
      </div>
    );
  }
  const deg = arrowBearing(guess.dir);
  return (
    <div className={`rs rs-row ${fresh ? "rs-new" : ""}`}>
      <div className="rs-city rs-strike">{guess.name}</div>
      <div className="rs-plate" aria-label={`${guess.km} км`}>
        {deg !== null && (
          <svg viewBox="0 0 16 16" width="16" height="16" style={{ transform: `rotate(${deg}deg)` }} aria-hidden="true">
            <path d="M8 1 L14 9 L10 9 L10 15 L6 15 L6 9 L2 9 Z" fill="currentColor" />
          </svg>
        )}
        {guess.km.toLocaleString("uk-UA")} км
      </div>
    </div>
  );
}

/** Gave up: the capital on a yellow detour sign. */
export function DetourSign({ answer, fresh }: { answer: string[]; fresh: boolean }) {
  return (
    <div className={`rs rs-detour ${fresh ? "rs-new" : ""}`}>
      <div className="rs-detour-top">ОБ'ЇЗД · СТОЛИЦЯ</div>
      <div className="rs-detour-name">{answer.join(" / ")}</div>
    </div>
  );
}
